<template>
    <div class="app-container">
        <div class="bg-container" :style="{backgroundImage: 'url(' + bgImage + ')'}">
            <div class="link-container">
                <div class="link" v-for="link in links" :key="link.id">
                    <a target="_blank" :href="link.url">
                        <img :src="link.cover" :alt="link.title">
                    </a>
                </div>
            </div>
        </div>
        <div class="banner-contaner"  :style="{backgroundImage: 'url(' + bannerBgImage + ')'}">
            <div class="butt-container">
                <div>
                    <img @click="goPre" src="../../assets/images/event_arrow.png" class="butt-pre"/>
                    <img @click="goNext" src="../../assets/images/event_arrow.png" class="butt-next"/>
                </div>
            </div>
            <div class="banners" v-if="banners.length > 0">
                <div>
                    <div class="banner-pre">
                        <img :src="bannerShow0.cover" :alt="bannerShow0.title">
                    </div>
                    <div class="banner-pre" :class="nextClicked?'next-clicked':''">
                        <img :src="bannerShow1.cover" :alt="bannerShow1.title">
                    </div>
                    <div class="banner-center" :class="preClicked?'pre-center':(nextClicked?'next-center':'')">
                        <a target="_blank" :href="bannerShow2.url">
                            <img :src="bannerShow2.cover" :alt="bannerShow2.title">
                        </a>
                    </div>
                    <div class="banner-next" :class="preClicked?'pre-clicked':''">
                        <img :src="bannerShow3.cover" :alt="bannerShow3.title">
                    </div>
                    <div class="banner-next">
                        <img :src="bannerShow4.cover" :alt="bannerShow4.title">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { useScreenState } from "../../store";
import request from '../../api/request'

export default {
    name: 'Map',
    data () {
        return {
            screenState: useScreenState(),
            bgImage: '',
            bannerBgImage: '',
            links: [
            ],
            banners: [
            ],
            offset: 0,
            nextClicked: false,
            preClicked: false,
        };
    },
    methods: {
        goPre () {
            if (!this.preClicked && !this.nextClicked && this.banners.length > 0) {
                this.preClicked = true;
                let _this = this
                setTimeout(function () {
                    _this.offset = (_this.offset + 1 + _this.banners.length) % _this.banners.length
                    _this.preClicked = false;
                }, 490)
            }
        },
        goNext () {
            if (!this.preClicked && !this.nextClicked && this.banners.length > 0) {
                this.nextClicked = true;
                let _this = this
                setTimeout(function () {
                    _this.offset = (_this.offset - 1 + _this.banners.length) % _this.banners.length
                    _this.nextClicked = false;
                }, 490)
            }
        },
        bannerShow(i) {
            if (this.banners.length > 0)
                return this.banners[(i + this.offset) % this.banners.length ]
        },
        getEvents () {
            let _this = this
            request.get('/events', {
                limit: 9999999, ordering: 'id'
                }).then(function (res) {
                if (res.status == 200) {
                    res = res.data.results.reduce(function(result, x) {
                        if (x.bg_type == 1) {
                            result.bg.push(x)
                        }
                        else if (x.bg_type == 2) {
                            result.links.push(x)
                        }
                        else if (x.bg_type == 3) {
                            result.banners.push(x)
                        }
                        return result
                    }, {
                        bg: [],
                        links: [],
                        banners: [],
                    })
                    _this.banners = res.banners
                    _this.links = res.links.slice(0, 5)
                    _this.bgImage = res.bg[0].cover
                    _this.bannerBgImage = res.bg[1].cover
                }
        })
        }
    },
    computed: {
        bannerShow0() {
            return this.bannerShow(0)
        }, 
        bannerShow1() {
            return this.bannerShow(1)
        }, 
        bannerShow2() {
            return this.bannerShow(2)
        }, 
        bannerShow3() {
            return this.bannerShow(3)
        }, 
        bannerShow4() {
            return this.bannerShow(4)
        }, 
    },
    mounted () {
        this.screenState.hideBreadcrumb = true
        this.getEvents()
    },
}
</script>

<style scoped>
.bg-container {
    width: 100vw;
    height: 50vw;
    background-position: center;
    background-size: cover;
}

.link-container {
    display: flex;
    padding-top: 38.23vw;
    margin: 0 auto;
    width: 90vw;
    max-width: 1090px;
}

.link {
    margin: auto;
}

.link img {
    width: 12vw;
    height: 12vw;
    max-width: 168px;
    max-height: 168px;
}

.banner-contaner {
    width: 100vw;
    height: 40.3125vw;
    background-position: center;
    background-size: cover;
    margin: 0 auto;
    position: relative;
    padding-top: 6.5625vw;
}

.banners {
    width: 100vw;
    position: absolute;
    top: 0;
    height: 40.3125vw;
}

.banners > div {
    width: 90vw;
    max-width: 1600px;
    height: 40.3125vw;
    margin: 0 auto;
    display: flex;
    position: relative;
    padding-top: 6.5625vw;
}

.banners > div > div {
    position: absolute;
}

.banners > div > div:nth-child(1), .banners > div > div:nth-child(5) {
    z-index: 1;
}

.banners > div > div:nth-child(2), .banners > div > div:nth-child(4) {
    z-index: 2;
}

.banners > div > div:nth-child(3) {
    z-index: 5;
}

.banners a, .banners img {
    width: 100%;
}

.banner-pre {
    width: 52%;
    left: 3.5%;
    padding-top: 2.5%;
}

.banner-center {
    width: 62%;
    right: 19%;
    padding-top: 1%;
}

.banner-next {
    width: 52%;
    right: 3.5%;
    padding-top: 2.5%;
}

.butt-container {
    width: 100vw;
    height: 40.3125vw;
}

.butt-container > div {
    width: 90vw;
    max-width: 1600px;
    padding-top: 13.48vw;
    margin: 0 auto;
    display: flex;
    position: relative;
}

.butt-pre, .butt-next{
    width: 12.5%;
    z-index: 6;
    cursor: pointer;
}

.butt-pre {
    margin-right: auto;
    transform: rotateY(180deg);
}

.butt-next {
    margin-left: auto;
}

.next-clicked {
    animation: scaleUpRight 0.5s ease-in-out infinite;
}

.pre-clicked {
    animation: scaleUpLeft 0.5s ease-in-out infinite;
}

.pre-center {
    animation: scaleDownLeft 0.5s ease-in-out infinite;
}

.next-center {
    animation: scaleDownRight 0.5s ease-in-out infinite;
}

@keyframes scaleUpLeft{
    0% {
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        z-index: 2;
    }
    100% {
        transform: scale(1.192);
        -webkit-transform: scale(1.192);
        -moz-transform: scale(1.192);
        right: 24.2%;
        padding-top: 4.65%;
        z-index: 5;
    }
  }

@keyframes scaleUpRight{
    0% {
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        z-index: 3;
    }
    100% {
        transform: scale(1.192);
        -webkit-transform: scale(1.192);
        -moz-transform: scale(1.192);
        left: 24.2%;
        padding-top: 4.65%;
        z-index: 5;
    }
  }

@keyframes scaleDownLeft{
    0% {
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        z-index: 5;
    }
    100% {
        transform: scale(0.8387);
        -webkit-transform: scale(0.8387);
        -moz-transform: scale(0.8387);
        right: 39.5%;
        margin-top: -2.5%;
        z-index: 3;
    }
  }

@keyframes scaleDownRight{
    0% {
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        left: 19%;
        z-index: 5;
    }
    100% {
        transform: scale(0.8387);
        -webkit-transform: scale(0.8387);
        -moz-transform: scale(0.8387);
        left: 39.5%;
        margin-top: -2.5%;
        z-index: 3;
    }
  }
</style>
